
import './Browse.css';
import bouquets from '../assets/constants/bouquets.js' 
import brickHeader from '../assets/images/brickHeader.png' 
import React from "react";

function Browse(props) {

    return (
        <div>
            <img src={brickHeader} alt="e-florals flower shop sign on a white brick building" className="brickHeaderimage"/>
            <h1 className="browseSubText"> pre-arranged bouquets </h1>
            <h1 className="browseSubSubText"> choose your favorite to send with a custom note </h1>
            <div className="bouquetRows">
                {bouquets.map((bouquet, index) => (
                    <div>
                        <img className="bouquetDisplay" onClick={() => props.setSelectedBouquet(bouquet)} src={bouquet.src} alt={bouquet.alt} />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Browse;